import type { SFAccount } from "../../components/testSite/AccountPicker";
import { ACCOUNT_AGNOSTIC_IDS } from "../../types/common";
import { QueryParam } from "../../utils/permission.utils";

export const globalAccountOptions: SFAccount[] = [
    {
        [QueryParam.SALESFORCE_ID]: ACCOUNT_AGNOSTIC_IDS.NO_IDENTIFIER,
        [QueryParam.SALESFORCE_NAME]: "No Account",
        [QueryParam.MARKETPLACE_ID]: undefined,
    },
];

export const icmAccountOptions: SFAccount[] = [
    {
        [QueryParam.SALESFORCE_ID]: "0011E00001iYShJQAW",
        [QueryParam.SALESFORCE_NAME]: "Insta360 Store - US",
        [QueryParam.MARKETPLACE_ID]: "1",
    },
    {
        [QueryParam.SALESFORCE_ID]: "0018000000vNbSLAA0",
        [QueryParam.SALESFORCE_NAME]: "Wellness Pet LLC - US",
        [QueryParam.MARKETPLACE_ID]: "1",
    },
];

export const accountOptions: SFAccount[] = [
    {
        [QueryParam.SALESFORCE_ID]: "0011E00001jnhfEQAQ",
        [QueryParam.SALESFORCE_NAME]: "Reckitt Hygiene- US",
        [QueryParam.MARKETPLACE_ID]: "1",
    },
    {
        [QueryParam.SALESFORCE_ID]: "0018000000Q9U3TAAV",
        [QueryParam.SALESFORCE_NAME]: "Microsoft - CA",
        [QueryParam.MARKETPLACE_ID]: "7",
    },
    {
        [QueryParam.SALESFORCE_ID]: "0018000000qxUneAAE",
        [QueryParam.SALESFORCE_NAME]: "Reckitt - DE",
        [QueryParam.MARKETPLACE_ID]: "4",
    },
    {
        [QueryParam.SALESFORCE_ID]: "0018000000RrNPlAAN",
        [QueryParam.SALESFORCE_NAME]: "Samsung Electronics - DE",
        [QueryParam.MARKETPLACE_ID]: "4",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "1",
        [QueryParam.SALESFORCE_ID]: "0018000000kd1MKAAY",
        [QueryParam.SALESFORCE_NAME]: "Adidas - US",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "1",
        [QueryParam.SALESFORCE_ID]: "0018000001BFSx1AAH",
        [QueryParam.SALESFORCE_NAME]: "American Tourister - US",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "3",
        [QueryParam.SALESFORCE_ID]: "0018000000SYNPkAAP",
        [QueryParam.SALESFORCE_NAME]: "Unilever - UK",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "328451",
        [QueryParam.SALESFORCE_ID]: "0011E00001nOs5EQAS",
        [QueryParam.SALESFORCE_NAME]: "LEGO - NL",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "338801",
        [QueryParam.SALESFORCE_ID]: "0011E00001jFb5fQAC",
        [QueryParam.SALESFORCE_NAME]: "Beiersdorf - UAE",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "338801",
        [QueryParam.SALESFORCE_ID]: "0011E00001jqNMcQAM",
        [QueryParam.SALESFORCE_NAME]: "L'Oreal - UAE",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "1",
        [QueryParam.SALESFORCE_ID]: "0018000000oJiELAA0",
        [QueryParam.SALESFORCE_NAME]: "Samsonite - US",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "1",
        [QueryParam.SALESFORCE_ID]: "0018000000MkzyHAAR",
        [QueryParam.SALESFORCE_NAME]: "Apple Hardware - US",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "4",
        [QueryParam.SALESFORCE_ID]: "0018000000tyXmLAAU",
        [QueryParam.SALESFORCE_NAME]: "Einhell - DE",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "3",
        [QueryParam.SALESFORCE_ID]: "0018000001I9GdWAAV",
        [QueryParam.SALESFORCE_NAME]: "Burt's Bees - UK",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "7",
        [QueryParam.SALESFORCE_ID]: "0011E00001iWV1TQAW",
        [QueryParam.SALESFORCE_NAME]: "Nestle (Purina) - CA",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "338801",
        [QueryParam.SALESFORCE_ID]: "0011E00001jFXYeQAO",
        [QueryParam.SALESFORCE_NAME]: "Nestle - UAE",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "7",
        [QueryParam.SALESFORCE_ID]: "0018000001Jynv3AAB",
        [QueryParam.SALESFORCE_NAME]: "Samsung - CA",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "5",
        [QueryParam.SALESFORCE_ID]: "0018000001Ta6VBAAZ",
        [QueryParam.SALESFORCE_NAME]: "Fossil - FR",
    },
];

export const nonEndemicAccountOptions: SFAccount[] = [
    {
        [QueryParam.MARKETPLACE_ID]: "3",
        [QueryParam.SALESFORCE_ID]: "0018000000txZIYAA2",
        [QueryParam.SALESFORCE_NAME]: "BMW - UK",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "5",
        [QueryParam.SALESFORCE_ID]: "0018000001FhEfsAAF",
        [QueryParam.SALESFORCE_NAME]: "Hyundai - FR",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "44551",
        [QueryParam.SALESFORCE_ID]: "00180000011diFjAAI",
        [QueryParam.SALESFORCE_NAME]: "The Walt Disney Company_Pictures - ES",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "771770",
        [QueryParam.SALESFORCE_ID]: "0011E00001oQzoPQAS",
        [QueryParam.SALESFORCE_NAME]: "HBO MAX - MX",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "1",
        [QueryParam.SALESFORCE_ID]: "0018000000MkYYkAAN",
        [QueryParam.SALESFORCE_NAME]: "American Express - US",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "7",
        [QueryParam.SALESFORCE_ID]: "0018000000w3alwAAA",
        [QueryParam.SALESFORCE_NAME]: "National Bank of Canada - CA",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "4",
        [QueryParam.SALESFORCE_ID]: "0011E00001ojIEBQA2",
        [QueryParam.SALESFORCE_NAME]: "Airbnb - DE",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "3",
        [QueryParam.SALESFORCE_ID]: "0018000000SDlxMAAT",
        [QueryParam.SALESFORCE_NAME]: "Vodafone - UK",
    },
    {
        [QueryParam.MARKETPLACE_ID]: "35691",
        [QueryParam.SALESFORCE_ID]: "0018000001VwY00AAF",
        [QueryParam.SALESFORCE_NAME]: "Iliad Italia S.p.A.",
    },
];
